//Add new product in below array when new product is omboarded

export const products = [
    {
        name: 'CODESYS Workbench',
        id: '9050c7a7-816b-4ea3-87e6-1602c89fd255',
    },
    {
        name: 'DTPG Configuration Tool',
        id: '6cecb3b3-9fa8-4f4e-a289-6ef1a013cdbd',
    },
    {
        name: 'Feeder Automation Manager',
        id: 'ff7ca44c-a623-4212-9938-05ed458bfb9a',
    },
    {
        name: 'Hydro-Québec SMP Gateway Automation Platform',
        id: 'a86ff578-c057-4ac2-8e67-d0c47cb1c2ee',
    },
    {
        name: 'IED Manager Suite',
        id: '093a2162-f765-11e9-8f0b-362b9e1556671aa',
    },
    {
        name: 'Demo VM - IED Manager Suite',
        id: '2911dd9b-06a1-4ed9-90dc-a0bba140d114',
    },    
    {
        name: 'SMP Distribution Automation Platform',
        id: '3acb1fdd-5f82-4cff-84ef-7db5ace4fa0a',
    },
    {
        name: 'Distributed I/O and RTU Upgrade solution',
        id: '21d49f8d-724b-4def-b49a-f3862f7fb165',
    },
    {
        name: 'SMP Gateway Automation Platform',
        id: '093a2162-f765-11e9-8f0b-362b9e1556672',
    },
    {
        name: 'SMP Configuration Comparison Tool',
        id: '36d72462-f765-11e9-8f0b-362b9e155667',
    },
    {
        name: 'SMP Tools',
        id: '618c533b-2633-40b6-87e0-849767a15106',
    },
    {
        name: 'Visual T&D',
        id: '22a689a5-ba30-4ac4-a3d3-c83e991e4602',
    },
    {
        name: 'Yukon Feeder Automation',
        id: 'fe8411cb-4ff2-4b93-a39f-139a145d1352',
    },
    {
        name: 'Yukon GridServer',
        id: '5b435882-1954-5b6a-9953-07e26578ccb2',
    },
    {
        name: 'Yukon Enterprise Software Platform',
        id: 'b7eec713-8da7-4476-9a9a-a7fc12cd085e',
    },
    {
        name: 'Yukon Network Manager',
        id: '46a1e753-7d13-43ff-a94d-c7a72052fa4f',
    },
    {
        name: 'Magnefix MD4 iCap',
       
        id: '9086e2ae-1a4c-4e5a-9de9-dcaed73bf5e7',
    },
    {
        name: 'Edge Platform',
        id: 'd634ad5f-b994-4d52-ad47-85b49ec59e7c',
    }
];
